import { createSlice } from '@reduxjs/toolkit';

export const qtyStatus = createSlice({
  name: 'qtyStatus',
  initialState: {
    data: false,
  },

  reducers: {
    setQtyStatus: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setQtyStatus } = qtyStatus.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.isLoading`
export const getQtyStatus = (state) => state.qtyStatus.data;

export default qtyStatus.reducer;
